export enum LocalStorageKeys {
  Cookie = 'accept-cookies',
  ConfirmEmailNDB = 'confirm-email-ndb-modal',
  BonusesLastSeenAt = 'bonuses-last-seen-at',
  PendingGoogleAuth = 'pending-google-auth',
  GoogleAuthRedirect = 'google-auth-redirect',
  AdditionalDataOrigin = 'additional-data-origin',
  AppSource = 'app-source',
  LotterySeenWins = 'lottery-seen-wins',
  LotteryOptOuts = 'lottery-opt-outs',
}

export class LocalStorage<T, U> {
  key: string;
  defaultValue: U;
  getStorage: () => Storage;

  constructor(
    key: string,
    emptyValue: U,
    // Resolved lazily — touching the property throws when site data is blocked.
    getStorage: () => Storage = () => localStorage
  ) {
    this.key = key;
    this.defaultValue = emptyValue;
    this.getStorage = getStorage;
  }

  get() {
    let item: string | null;

    // Reading throws outright when site data is blocked.
    try {
      item = this.getStorage().getItem(this.key);
    } catch {
      return this.defaultValue;
    }

    try {
      if (item == null) return this.defaultValue;
      return JSON.parse(item) as T;
    } catch {
      return (item as any as T) || this.defaultValue;
    }
  }

  push(object: T) {
    const oldObject = this.get();

    if (Array.isArray(oldObject) && Array.isArray(object)) {
      this.replace([...oldObject, ...object] as any as T);
    } else if (Array.isArray(oldObject) && typeof object === 'object') {
      this.replace([...oldObject, object] as any as T);
    } else if (oldObject != null && typeof oldObject === 'object') {
      this.replace({ ...oldObject, ...object } as any as T);
    } else {
      this.replace(object);
    }
  }

  replace(object: T) {
    const json = JSON.stringify(object);

    try {
      this.getStorage().setItem(this.key, json);
    } catch {
      // Nothing to fall back on — callers must keep working without storage.
    }
  }

  remove() {
    try {
      this.getStorage().removeItem(this.key);
    } catch {
      // See replace().
    }
  }
}
